






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PreviewDefaultFieldVue extends Vue {
  @Prop()
  readonly label!: string;

  @Prop()
  readonly value!: any;
}
